module.exports = __webpack_public_path__ + "static/media/dmt.dc87caea.svg";